export default "__VITE_ASSET__CxqtNMqo__"